<div previewForm style="padding-top: 0px; padding-left: 16px; padding-right: 16px;">

    <mat-tab-group [selectedIndex]="selectedTab" (selectedIndexChange)="changeTab($event)">
        <mat-tab label="Formulari">
            <ng-container *ngTemplateOutlet="fbPreviewForm"></ng-container>
        </mat-tab>
        
        <mat-tab label="Definició">
            <ng-container *ngTemplateOutlet="fbDefinitionForm"></ng-container>
        </mat-tab>

        <mat-tab label="Valors">
            <ng-container *ngTemplateOutlet="fbValueForm"></ng-container>
        </mat-tab>

        <mat-tab label="Esquema JSON">
            <ng-container *ngTemplateOutlet="fbSchemaForm"></ng-container>
        </mat-tab>
    </mat-tab-group>

    <ng-template #fbPreviewForm>

        <div class="tab-container mat-elevation-z8" style="width: fit-content; max-width: 785px; min-width: 777.5px;">

            <form [formGroup]="fv.form" (ngSubmit)="submit()" >
                <formly-form [form]="fv.form" [fields]="fv.fields" [model]="fv.model" [options]="fv.options">
                </formly-form>
            </form>

            <ng-container *ngIf="section && section.items && section.items.length==0" [ngTemplateOutlet]="empty">

            </ng-container>

        </div>

    </ng-template>
    
    <ng-template #fbDefinitionForm>

        <div class="tab-container mat-elevation-z8" style="width: fit-content; max-width: 785px; min-width: 777.5px;">

            <button mat-icon-button [cdkCopyToClipboard]="section|json" style="padding-left: 20px;">
                <mat-icon>content_copy</mat-icon>
            </button>
            <pre [innerHTML]="prettyPrint(section)"></pre>

        </div>

    </ng-template>
    
    <ng-template #fbValueForm>

        
        <div class="tab-container mat-elevation-z8" style="width: fit-content; max-width: 785px; min-width: 777.5px;">
            <button mat-icon-button [cdkCopyToClipboard]="fv.form.value|json">
                <mat-icon>content_copy</mat-icon>
            </button>
            <pre [innerHTML]="prettyPrint(fv.form.value)"></pre>
            
        </div>
        

    </ng-template>
    
    <ng-template #fbSchemaForm>

        <div class="tab-container mat-elevation-z8" style="width: fit-content; max-width: 785px; min-width: 777.5px;">

            <button mat-icon-button [cdkCopyToClipboard]="toSchema()|json">
                <mat-icon>content_copy</mat-icon>
            </button>
            <pre [innerHTML]="prettyPrint(toSchema())"></pre>

        </div>

    </ng-template>
   
</div>

<ng-template #empty>
    <app-page-empty-search-result 
        [description]="'Aquí podràs veure els camps de la secció'" iconName="visibility" image="preview"></app-page-empty-search-result>
</ng-template>